import { Directive, ElementRef, Input } from "@angular/core";
import { isNullOrUndefined } from 'src/app/services/utils';
import { COMMON_CONSTANTS} from '../../common/core/common.constants';

@Directive({
  selector: "[appHighlight]"
})
export class HighlightDirective {
  private _content: string;
  private _searchTerm: string;
  private separatedText = [];
  private separatedSearchedText = [];
  private final = "";
  searchPattern: any;
  matchpattern: any;
  splitFlag = "";
  matchFlag = "";
  spanStart = '<span class="text-highlight">';
  spanEnd = "</span>";

  @Input("content")
  set content(content: string) {
    this._content = content;
  }
  get content(): string {
    return this._content;
  }

  @Input("searchTerm")
  set searchTerm(searchTerm: string) {
    this._searchTerm = searchTerm;

    // checking for Internet browser
    const isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
    if (!isIEOrEdge) {
      this.highlight();
    }
  }
  get searchTerm(): string {
    return this._searchTerm;
  }

  @Input() caseSensitive: boolean;

  constructor(private el: ElementRef) {
    this.caseSensitive = COMMON_CONSTANTS.FALSE_VAL;
  }

  highlight() {
    this.final = "";
    if (!this.caseSensitive) {
      this.splitFlag = "i";
      this.matchFlag = "gi";
    } else {
      this.splitFlag = "";
      this.matchFlag = "g";
    }
    this.searchPattern = new RegExp(this._searchTerm, this.splitFlag);
    this.matchpattern = new RegExp(this._searchTerm, this.matchFlag);

    if (
      this._searchTerm !== undefined &&
      this._searchTerm != null &&
      this._searchTerm.length > COMMON_CONSTANTS.DIGITS.ZERO &&
      this._searchTerm[COMMON_CONSTANTS.DIGITS.ZERO] !== "." &&
      !isNullOrUndefined(this._content)
    ) {
      this.separatedText = this._content.split(this.searchPattern);
      this.separatedSearchedText = this._content.match(this.matchpattern);

      if (
        this.separatedSearchedText != null &&
        this.separatedSearchedText.length > COMMON_CONSTANTS.DIGITS.ZERO
      ) {
        for (let i = COMMON_CONSTANTS.DIGITS.ZERO; i < this.separatedText.length; i++) {
          this.checkForSeperatedTextLength(i);
        }
      }
      if (this.final.length > COMMON_CONSTANTS.DIGITS.ZERO) {
        this.el.nativeElement.innerHTML = "";
        this.el.nativeElement.innerHTML = this.final;
      } else {
        this.el.nativeElement.textContent = this._content;
      }
    } else {
      this.el.nativeElement.textContent = this._content;
    }
  }

  checkForSeperatedTextLength(i){
    if (i <= this.separatedSearchedText.length - COMMON_CONSTANTS.DIGITS.ONE) {
      this.final +=
        this.separatedText[i] +
        this.spanStart +
        this.separatedSearchedText[i] +
        this.spanEnd;
    } else {
      this.final += this.separatedText[i];
    }
  }

}
